import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_PRIORIDADES = `${modulo.GESTAO_DE_DEMANDAS}/prioridades`

const actions = {
  findAll ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: URL_PRIORIDADES
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/demandas/prioridades.js